import { render } from "./LegacyRow.vue?vue&type=template&id=5bb79944&scoped=true"
import script from "./LegacyRow.vue?vue&type=script&lang=js"
export * from "./LegacyRow.vue?vue&type=script&lang=js"

import "./LegacyRow.vue?vue&type=style&index=0&id=5bb79944&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb79944"]])

export default __exports__